import classNames from 'classnames';
import React, { FC, useState } from 'react'
import { Collapse } from 'react-collapse';

import { useInsuranceLabels } from '../../../../Utils/Context/labelsContext';
import { Button } from '../../../../Partials/Button';

import { GeneralInfoBodyPart } from './GeneralInfoBodyPart';

interface GeneralInfoBodyBioProps {
  bio: string;
}

export const GeneralInfoBodyBio: FC<GeneralInfoBodyBioProps> = (props) => {
  const { bio } = props;
  const [bioVisible, setBioVisible] = useState(false);
  
  const {
    headings
  } = useInsuranceLabels();

  const [bioFirstPart, ...bioRest] = (bio ?? "")
    .split("</p>")
    .filter((p) => !!p);

  return (
    <GeneralInfoBodyPart
      className={classNames(
        "generalBodyInfoBio",
        !bioVisible && "generalBodyInfoBio--collapsed"
      )}
      header={headings.bioHeading}
    >
      <div
        className="generalBodyInfoBio__bioIntro"
        dangerouslySetInnerHTML={{
          __html: bioFirstPart + '</p>'
        }}
      />
      {bioRest?.length > 0 && (
        <Collapse
          isOpened={bioVisible}
          theme={{ collapse: "react-collapse--collapse" }}
        >
          <div
            id="general-body-bio"
            className="generalBodyInfoBio__bioRest"
            dangerouslySetInnerHTML={{
              __html:
                bioRest.filter((part) => part.length != 0).join("</p>") +
                "</p>",
            }} />
        </Collapse>
      )}
      {bioRest?.length != 0 && (
        <div className="generalBodyInfoBio__controls">
          <Button
            aria-expanded={bioVisible}
            aria-controls="general-body-bio"
            onClick={() => setBioVisible(!bioVisible)}
            type="clear"
            tier="primary"
            size="medium"
          >
            {bioVisible ? "Vis mindre" : "Vis mer"}
          </Button>
        </div>
      )}
    </GeneralInfoBodyPart>
  )
};
